import Vue from 'vue'
import router from '../../router'
import moment from 'moment'

export const settlements = {
    state: {
        status: 'idle',
        settlements: null,
        activeTab: 0,
        pagination: {
            page: 1,
            totalPages: 0,
            perPage: 10,
            totalRecords: null
        },
        selectedSettlements: [],
        selectAllSettlements: false,
        includes:
            'company,company.logo,company.logo_vertical,parametrization,document_pdf,document_report,parametrization.external_crm_dict_service',
        downloadStatus: 'idle',
        sortOptions: [
            {
                query: 'amount',
                label: 'Kwota'
            },
            {
                query: 'created_at',
                label: 'Data dokumentu'
            }
        ],
        sort: {
            by: 'created_at',
            direction: 'desc'
        },
        activeSettlement: null,
        activeSettlementReport: null,
        filters: {
            paid: {
                type: 'ui-checkbox-input',
                value: false,
                text: 'Tylko opłacone',
                // TODO: Only paid document filter hidden in #501
                hidden: true
            },
            ready_to_share_report: {
                type: 'ui-checkbox-input',
                value: false,
                text: 'Raport do pobrania',
                // TODO: Ready to share report filter hidden in #501
                hidden: true
            },
            title: {
                type: 'search-input',
                value: '',
                searchParamsTooltip: ['numerze dokumentu']
            },
            sale_date: {
                type: 'dates',
                value: '',
                text: 'Data dokumentu',
                additionalText: 'Data'
            },
            company_id: {
                type: 'ui-virtual-list',
                value: [],
                searcher: false,
                getter: 'getCompaniesForPromoFilters',
                label: 'Organizator',
                // TODO: Company filter hidden in #501
                hidden: true
            },
            status: {
                type: 'checkboxes',
                value: [],
                getter: 'getSettlementStatuses',
                text: 'Status księgowania',
                firstOption: 'Wszystkie',
                singleSelect: true
            },
            'parametrization|document_name_id': {
                type: 'checkboxes',
                value: [],
                getter: 'getParametrizationDocumentTypesForFilter',
                text: 'Typ dokumentu',
                firstOption: 'Wszystkie',
                singleSelect: true
            },
            nip: {
                type: 'checkboxes',
                value: [],
                getter: 'getUserAllCompaniesForSelect',
                text: 'Moje firmy',
                firstOption: 'Wszystkie',
                singleSelect: true,
                additionalText: 'Firma'
            },
            downloaded: {
                type: '',
                value: false,
                hidden: true
            },
            'parametrization|external_crm_dict_service|code': {
                type: '',
                value: null,
                hidden: true
            }
        },
        progressBar: {
            percentage: 0,
            processed_count: 0,
            total_count: 0,
            finished: false
        },
        parametrizationDocumentTypes: [],
        downloadedSettlementsCounter: null
    },
    mutations: {
        SET_DOWNLOADED_SETTLEMENTS_COUNTER(state, payload) {
            state.downloadedSettlementsCounter = payload
        },
        SET_SETTLEMENTS_STATUS(state, status) {
            state.status = status
        },
        SET_SETTLEMENTS(state, settlements) {
            state.settlements = settlements
        },
        SELECT_SETTLEMENTS(state, payload) {
            state.selectedSettlements = payload
        },
        SET_SELECT_ALL_SETTLEMENTS(state, payload) {
            state.selectAllSettlements = payload
        },
        SET_SETTLEMENTS_PAGINATION(state, payload) {
            state.pagination = payload
        },
        SET_SETTLEMENTS_PER_PAGE(state, payload) {
            state.pagination.perPage = payload
        },
        SET_SETTLEMENTS_CURRENT(state, payload) {
            state.pagination.page = payload
        },
        SET_SETTLEMENTS_DOWNLOAD_STATUS(state, payload) {
            state.downloadStatus = payload
        },
        SET_SETTLEMENTS_SORT(state, payload) {
            state.sort = payload
        },
        SET_ACTIVE_NOTE(state, payload) {
            state.activeSettlement = payload
        },
        SET_ACTIVE_REPORT(state, payload) {
            state.activeSettlementReport = payload
        },
        SET_SETTLEMENTS_ACTIVE_TAB(state, payload) {
            state.activeTab = payload
        },
        SET_SETTLEMENTS_FILTER(state, payload) {
            Vue.set(state.filters[payload.filter], 'value', payload.value)
        },
        RESET_SETTLEMENTS_FILTERS(state, payload) {
            Vue.set(state, 'filters', payload)
        },
        SET_SETTLEMENTS_PROGRESSBAR(state, payload) {
            Vue.set(state, 'progressBar', payload)
        },
        RESET_SETTLEMENTS_PROGRESSBAR(state, payload) {
            Vue.set(state, 'filters', payload)
        },
        SET_FILTERS(state, payload) {
            state.filters = payload
        },
        SET_PARAMETRIZATION_DOCUMENT_TYPES(state, payload) {
            state.parametrizationDocumentTypes = payload
        }
    },
    actions: {
        setSettlementsPerPage({ commit }, payload) {
            commit('SET_SETTLEMENTS_PER_PAGE', payload)
        },
        setDownloadedSettlementsCounter({ commit }, payload) {
            commit('SET_DOWNLOADED_SETTLEMENTS_COUNTER', payload)
        },
        async fetchParametrizationDocumentTypes({ commit, state }) {
            const isArchiveTab = state.activeTab === 2
            const activeTab = isArchiveTab ? null : state.activeTab === 1
            let params = {}
            if (!isArchiveTab) {
                params['_group[1][parametrization.other_document.downloaded]'] = activeTab
                params['_group[1][parametrization.external_crm_dict_service.code]'] = 'PROP,PUBL,ZDRA'
                params['_group[2][parametrization.other_document.downloaded]'] = activeTab
                params['_group[2][parametrization.external_crm_dict_service_id]'] = 'nil'
            } else {
                params = {
                    'parametrization.external_crm_dict_service.code': 'ARCH'
                }
            }
            this.$api
                .get('/settlements/document_names', {
                    params
                })
                .then(({ data, status }) => {
                    if (status !== 200) {
                        throw new Error(data.message || 'Failed GET document types')
                    }
                    commit('SET_PARAMETRIZATION_DOCUMENT_TYPES', data.data || [])
                })
                .catch(error => {
                    console.log(error)
                })
        },
        async settlementsFetch({ state, commit, dispatch, getters }) {
            commit('SET_SETTLEMENTS_STATUS', 'loading')
            await dispatch('setSettlementsDefaultFilters')
            if (router.currentRoute.query.page) {
                commit(
                    'SET_SETTLEMENTS_CURRENT',
                    +router.currentRoute.query.page
                )
            }
            if (router.currentRoute.query.show) {
                commit(
                    'SET_SETTLEMENTS_PER_PAGE',
                    +router.currentRoute.query.show
                )
            }

            dispatch('saveLocalForagePagination', {
                settlements: state.pagination.perPage
            })

            const params = {
                ...getters.getSettlementsQueryParams('GET'),
                page: state.pagination.page,
                per: state.pagination.perPage,
                includes: state.includes,
                sort: state.sort.by,
                direction: state.sort.direction
            }
            this.$api
                .get('settlements/documents', {
                    params
                })
                .then(response => {
                    const { perPage, page, totalPages, totalRecords, nextPage, prevPage } = response.data.pagination[0]
                    const pagination = {
                        perPage: +perPage,
                        page: +page,
                        totalPages: +totalPages,
                        totalRecords: +totalRecords,
                        nextPage: +nextPage,
                        prevPage: +prevPage
                    }
                    if (
                        pagination.page > 1 &&
                        pagination.page > pagination.totalPages
                    ) {
                        commit('SET_SETTLEMENTS_CURRENT', 1)
                        router.push('/settlements?page=1')
                    }
                    commit('SET_SETTLEMENTS_PAGINATION', pagination)
                    commit('SET_SETTLEMENTS', response.data.data)
                    commit('SET_SELECT_ALL_SETTLEMENTS', false)
                    commit('SET_SETTLEMENTS_STATUS', 'idle')
                })
                .catch(err => {
                    if (!this.$api.isCancel(err)) {
                        commit('SET_SETTLEMENTS_STATUS', 'idle')
                    }
                })
        },
        downloadSettlement({ state, commit, dispatch }, { documentId, type }) {
            if (state.downloadStatus === 'loading') {
                return
            }

            commit(`SET_ACTIVE_${type.toUpperCase()}`, documentId)
            commit('SET_SETTLEMENTS_DOWNLOAD_STATUS', 'loading')

            return this.$api
                .get(`/settlements/documents/${documentId}/${type}`, {
                    params: {
                        mark_as_exported: type === 'note' ? true : undefined
                    },
                    responseType: 'arraybuffer'
                })
                .then(response => {
                    if (response?.status !== 200) {
                        throw new Error(response?.response?.statusText || 'Failed GET document')
                    }

                    const today = Vue.moment().format('DD-MM-YYYY HH:mm:ss')

                    const fileLink = document.createElement('a')
                    const blob = new Blob([response.data], {
                        type: '"application/octet-stream"'
                    })

                    const extension = type === 'note' ? 'pdf' : 'xls'
                    fileLink.href = window.URL.createObjectURL(blob)
                    fileLink.download = `Rozliczenia-${today}.${extension}`
                    fileLink.click()
                })
                .catch(error => {
                    return {
                        error
                    }
                })
                .finally(() => {
                    commit('SET_SETTLEMENTS_DOWNLOAD_STATUS', 'idle')
                    commit(`SET_ACTIVE_${type.toUpperCase()}`, null)
                })
        },
        downloadSettlements({ commit, getters, dispatch, state }, payload) {
            let filters = {}
            if (payload.downloadType) {
                for (const [key, value] of Object.entries(getters.getSettlementsQueryParams('POST'))) {
                    if (value !== null) {
                        const keyValue = key.includes('|') ? key.replaceAll('|', '.') : key
                        filters[keyValue] = value
                    }
                }
                if (payload.downloadType === 'last_month') {
                    const firstDay = moment()
                        .subtract(30, 'days')
                    const lastDay = moment()
                    filters._group[1].sale_date = `${firstDay},${lastDay}`
                    filters._group[2].sale_date = `${firstDay},${lastDay}`
                }
            } else {
                filters = {
                    id: getters.getSelectedSettlementsIds.join(',')
                }
            }
            this.$api
                .post('bundles', {
                    type: `Bundle::OtherDocument::${payload.bundleType}`,
                    filters: filters
                })
                .then(res => {
                    if (res.data.data && !res.data.data.errors) {
                        dispatch('openModal', {
                            component: 'ModalSettlementsProcess'
                        })
                        let finished = false
                        let processedCount = 0
                        const checkBundle = () => {
                            this.$api
                                .get(
                                    `bundles/${res.data.data.id}?includes=bundle.bundle`
                                )
                                .then(resp => {
                                    if (resp.data.data) {
                                        finished = resp.data.data.finished
                                        processedCount =
                                            resp.data.data.processed_count

                                        if (finished) {
                                            setTimeout(() => {
                                                const fileLink = document.createElement(
                                                    'a'
                                                )
                                                fileLink.href =
                                                    resp.data.data.bundle.urls.original
                                                fileLink.setAttribute(
                                                    'download',
                                                    true
                                                )
                                                fileLink.click()
                                            }, 400)
                                        }
                                        const progressBar = {
                                            bundle_document_type:
                                                payload.bundleType,
                                            percentage:
                                                resp.data.data.percentage,
                                            processed_count:
                                                resp.data.data.processed_count,
                                            total_count:
                                                resp.data.data.total_count,
                                            finished: resp.data.data.finished
                                        }
                                        commit(
                                            'SET_SETTLEMENTS_PROGRESSBAR',
                                            progressBar
                                        )
                                    }
                                })
                                .catch(() => {})
                        }
                        checkBundle()
                        const timer = setInterval(function() {
                            if (!finished) {
                                checkBundle()
                            }
                            if (finished) {
                                if (
                                    payload.bundleType === 'Note' &&
                                    state.activeTab === 0
                                ) {
                                    dispatch(
                                        'setDownloadedSettlementsCounter',
                                        state.downloadedSettlementsCounter +
                                            processedCount
                                    )
                                }

                                clearInterval(timer)
                            }
                        }, 2000)
                    } else {
                        if (res.data.data === null) {
                            dispatch('addNotification', {
                                type: 'danger',
                                content: 'Brak dokumentów do pobrania'
                            })
                        } else {
                            if (res.data.data.errors) {
                                let errorMessage = 'Spróbuj ponownie później.'
                                const {
                                    base,
                                    context_id: contextId
                                } = res.data.data.errors

                                if (base && base[0].messages) {
                                    errorMessage = base[0].messages
                                } else if (contextId && contextId[0].messages) {
                                    errorMessage = contextId[0].messages
                                }

                                dispatch('addNotification', {
                                    type: 'danger',
                                    content: `Wystąpił błąd. ${errorMessage}`
                                })
                            }
                        }
                    }
                })
        },
        resetSettlementsProgressBar({ commit }) {
            return this.$storage.getItem('initialState').then(response => {
                commit(
                    'SET_SETTLEMENTS_PROGRESSBAR',
                    response.settlements.progressBar
                )
            })
        },
        selectSettlement({ state, commit, dispatch }, payload) {
            let settlements = state.selectedSettlements
            const settlementIds = settlements.map(item => item.id)

            if (settlementIds.includes(payload.id)) {
                // remove from selected settlements
                settlements = settlements.filter(item => item.id !== payload.id)
                commit('SET_SELECT_ALL_SETTLEMENTS', false)
            } else {
                const settlement = state.settlements.find(
                    item => item.id === payload.id
                )
                settlements.push(settlement)
            }

            if (settlements.length === 0) {
                dispatch('toggleModal', false)
            }
            this.$storage.setItem('selectedSettlements', settlements)
            commit('SELECT_SETTLEMENTS', settlements)
        },
        selectAllSettlements({ commit, state }, payload) {
            if (payload) {
                const settlements = state.settlements
                const selectedSettlements = state.selectedSettlements
                selectedSettlements.forEach(item => {
                    settlements.push(item)
                })
                // remove duplicates
                const unique = [
                    ...new Map(
                        settlements.map(item => [item.id, item])
                    ).values()
                ]

                this.$storage.setItem('selectedSettlements', unique)
                commit('SELECT_SETTLEMENTS', unique)
            } else {
                this.$storage.setItem('selectedSettlements', [])
                commit('SELECT_SETTLEMENTS', [])
            }
            commit('SET_SELECT_ALL_SETTLEMENTS', payload)
        },
        setSettlementsSort({ commit }, payload) {
            commit('SET_SETTLEMENTS_SORT', payload)
        },
        setSettlementsActiveTab({ commit }, payload) {
            commit('SET_SETTLEMENTS_ACTIVE_TAB', payload)
        },
        setSettlementsDefaultFilters({ commit, state }) {
            const defaultFilters = state.filters
            const isDownloadedTab = state.activeTab === 1
            const isArchiveTab = state.activeTab === 2

            defaultFilters.downloaded.value = isArchiveTab ? null : isDownloadedTab
            // TODO: Ready to share report filter hidden in #501
            // defaultFilters.ready_to_share_report.hidden = isDownloadedTab
            defaultFilters.sale_date.hidden = isArchiveTab
            defaultFilters.nip.hidden = isArchiveTab
            if (isArchiveTab) {
                defaultFilters.sale_date.value = null
                defaultFilters.nip.value = []
            }
            defaultFilters['parametrization|external_crm_dict_service|code'].value = isArchiveTab ? 'ARCH' : 'PROP,PUBL,ZDRA'
            commit('SET_FILTERS', defaultFilters)
            commit('SET_SETTLEMENTS_PAGINATION', {
                page: 1,
                totalPages: 0,
                perPage: 10,
                totalRecords: null
            })
        }
    },
    getters: {
        getParametrizationDocumentTypesForFilter: (state) => {
            return state.parametrizationDocumentTypes?.map(type => {
                return {
                    value: type.id,
                    label: type.name
                }
            })
        },
        getSettlements: state => {
            if (state.settlements) {
                return state.settlements
            }
        },
        getSettlementsStatus: state => {
            return state.status
        },
        getSelectedSettlements: state => {
            return state.selectedSettlements
        },
        getSelectedSettlementsIds: state => {
            return state.selectedSettlements.map(el => el.id)
        },
        getSelectedSettlement: state => id => {
            if (state.selectedSettlements) {
                if (
                    state.selectedSettlements.find(
                        el => el !== undefined && el.id === id
                    )
                ) {
                    return state.selectedSettlements.find(
                        el => el !== undefined && el.id === id
                    )
                } else {
                    return false
                }
            } else {
                return false
            }
        },
        getSettlementsSelectAll: state => {
            return state.selectAllSettlements
        },
        getSettlementsPagination: state => {
            return state.pagination
        },
        getSettlementsDownloadStatus: state => {
            return state.downloadStatus
        },
        getSettlementsSortOptions: state => {
            return state.sortOptions
        },
        getSettlementsSort: state => {
            return state.sort
        },
        getSettlementsSortDirection: state => {
            return state.direction
        },
        getActiveSettlement: state => id => {
            return state.activeSettlement === id ? 'loading' : 'idle'
        },
        getActiveSettlementReport: state => id => {
            return state.activeSettlementReport === id ? 'loading' : 'idle'
        },
        getSettlementsActiveTab: state => {
            return state.activeTab
        },
        getSettlementsFilters: state => {
            return state.filters
        },
        getSelectedSettlementsCount: state => {
            return state.selectedSettlements.length
        },
        getSettlementsProgressBar: state => {
            return state.progressBar
        },
        getSettlementsDownloadCounter: state => {
            return state.downloadedSettlementsCounter
        },
        getSettlementsQueryParams: (state) => method => {
            const filters = state.filters
            let params = {}
            for (const [filter, value] of Object.entries(filters)) {
                if (typeof value.value === 'boolean') {
                    if (
                        filter === 'paid' ||
                        filter === 'ready_to_share_report'
                    ) {
                        if (!value.hidden && value.value) {
                            params = {
                                ...params,
                                [filter]: value.value
                            }
                        }
                    } else {
                        params = {
                            ...params,
                            [filter]: value.value
                        }
                    }
                } else if (value.value) {
                    if (filter === 'status') {
                        if (value.value.length > 0) {
                            params = {
                                ...params,
                                [value.value[0]]: true
                            }
                        }
                    } else if (Array.isArray(value.value)) {
                        if (value.value.length > 0) {
                            const values = value.value.map((item) => {
                                return item
                            })
                            params = {
                                ...params,
                                [filter]: values.join(',')
                            }
                        }
                    } else if (filter === 'sale_date') {
                        const dates = value.value.split(',')
                        params = {
                            ...params,
                            sale_date: `${moment(dates[0])},${moment(dates[1])}`
                        }
                    } else {
                        params = {
                            ...params,
                            [filter]: value.value
                        }
                    }
                }
            }

            if (state.activeTab !== 2) {
                const paramsGET = {}
                const paramsPOST = {
                    _group: {
                        1: {},
                        2: {}
                    }
                }

                for (const [key, value] of Object.entries(params)) {
                    const keyValue = key.includes('|') ? key.replaceAll('|', '.') : key

                    paramsPOST._group[1][keyValue] = value.toString()
                    paramsGET[`_group[1][${keyValue}]`] = value

                    if (keyValue !== 'parametrization.external_crm_dict_service.code') {
                        paramsPOST._group[2][keyValue] = value.toString()
                        paramsGET[`_group[2][${keyValue}]`] = value
                    }
                }
                paramsPOST._group[2]['parametrization.external_crm_dict_service_id'] = 'nil'
                paramsGET['_group[2][parametrization.external_crm_dict_service_id]'] = 'nil'
                params = method === 'POST' ? paramsPOST : paramsGET
            }
            return params
        },
        getSettlementStatuses: () => {
            return [{
                value: 'ready_to_share_document',
                label: 'Rozliczenia z dokumentem księgowym'
            }]
        }
    }
}
